import { applicationUrls } from 'sharedweb/helpers/urls';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    CancelOrderResponse, ConvertProductRequest, ConvertProductRsponse, EdisAuthUnauth,
    MutualFundDataResponse,
    MutualFundHoldingResponse,
    MutualFundHoldingResponseRealTime,
    OrderNotificationParams
} from '../../../../../app.interfaces';
import {
    OrderBookDataResponse, CancelOrderRequest, OrderBookResponse, UserBookFilters, HoldingBookFilters,
    PositionResponse, HoldingResponse, TradesResponseInterface, ProductConversionSummaryResponse,
    FundsTransactionFilter, TransactionHistoryParams, UserBookFiltersInterface, orderResponse, tradeResponse,
    HoldingResponseObj,
    TradesResponseDataInterface,
    DialogTypeData,
    PledgeConfirmStatusResponse,
    PledgeConfirmStatusRows,
    SubTabs,
    TradeStruct,
    GTTBookResponse,
    GTTOrderBookTable,
    MtfHoldingResponse,
    ApprovedStockListResponse,
    MtfHoldingResponseObj,
    MtfMarginResponseObj,
    SmartBookResponse,
    SmartBookTable,
} from 'sharedweb/app.interface';
import { Holding, MarketWatch, MutualFund, OrderBook, TradeBook, SymbolRow, Order, GTTBook, HoldingStore, MtfHolding } from 'sharedweb/app.models';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { startWith, map, tap, share } from 'rxjs/operators';
import { of, Observable, Subscription, Subject } from 'rxjs';
import { SocketService } from '@socket/socket.service';
import { SocketConnections, SockRoutes, OrderStatus, OrderCategory, SortingTypes, ExecutedOrderStatus, PledgeStatus, PledgeResponseStatus, CustomDateTimeFormat } from 'sharedweb/app.structs';
import { EventsService } from '@event-service';
import { EVENTS, CURRENT_PLATFORMTYPE, Utils, REG_EX, IS_SMART_ENABLED_DEFAULT} from 'src/app/_helpers';
import { VALID_ORDERS } from 'sharedweb/helpers/shared-constants';
import { SharedUtils } from 'sharedweb/helpers/shared.utilities';
import { LoggingService } from 'sharedweb/providers/logging/logging.service';
import { ToastrService } from 'ngx-toastr';
import { ConfigParamsService } from 'sharedweb/providers/config-params/config-params.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AuthorizationHoldingsSelectorComponent } from 'src/app/_shared/components/authorization-holdings-selector/authorization-holdings-selector.component';
import { RMSOutcome as RMSOutcomeErroMap } from 'sharedweb/providers/utProto/enums_pb';
import { SymbolSearchService } from 'sharedweb/providers/symbol-search/symbol-search.service';
import { OrderNotificationService } from 'src/app/_shared/providers/order-notification/order-notification.service';
import { PledgeStatusNudgeComponent } from 'src/app/_shared/components/nudges/pledge-status-nudge/pledge-status-nudge.component';
import { BOOK_TABS, ORDER_STATUS_TAB_MAPPING } from 'sharedweb/app.structs';
import { SuperBook } from 'sharedweb/app.models';
import { WEB_SM_FeEventType, WEB_SmartOrderType } from 'sharedweb/providers/utProto/webSmartOrder_pb';
import { SuperBookOrderModeDisplay, SuperBookOrderStatusDisplay, VendorType } from 'src/app/app.structs';
import * as moment from 'moment';
import { ConfigurationService } from 'src/app/_shared/providers/configuration/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class UserBooksService {
    private rejectedOrderIds = new Set<string>();
    private _subscriptions: Subscription = new Subscription();
    lastestSeqNum = 0;
    cachedHoldings: HoldingResponse;
    cachedOrders: OrderBook[];
    cachedTrades: TradeBook[];
    cachedPositions: PositionResponse;
    cachedMutualFunds: MutualFund[];
    cachedGTTOrders: GTTBook[];
    cachedSuperOrders: SuperBook[] = [];
    cachedSmartOrders: SuperBook[] = [];
    $holdingRequest: Observable<HoldingResponse>;
    $positionRequest: Observable<PositionResponse>;
    $orderRequest: Observable<OrderBookResponse>;
    $tradesRequest: Observable<TradesResponseInterface>;
    $gttRequest: Observable<GTTBookResponse>;
    $superRequest: Observable<SmartBookResponse>;
    $smartRequest: Observable<SmartBookResponse>;
    processedOrderId: string; //stotres the order id of the last processed order
    private positionView: string = "";
    private pledgeStatusDialogRef: MatDialogRef<PledgeStatusNudgeComponent> = null;

    readonly orderBookStream = new Subject<orderResponse>();
    readonly tradebookStream = new Subject<tradeResponse>();
    readonly positionStream = new Subject<PositionResponse>();
    readonly holdingStream = new Subject<HoldingResponseObj>();
    readonly mtfStream = new Subject<MtfHoldingResponseObj>();
    readonly mtfMarginStream = new Subject<MtfMarginResponseObj>();
    readonly mutualFundStream = new Subject<MutualFundDataResponse[]>();
    readonly gttBookStream = new Subject<GTTBookResponse>();
    readonly superBookStream = new Subject<SmartBookResponse>();
    readonly smartBookStream = new Subject<SmartBookResponse>();

    filterValidator = SharedUtils.filterValidator;

    orderbookFilters: UserBookFiltersInterface = {};
    tradebookFilters: UserBookFiltersInterface = {};
    gttBookFilters: UserBookFiltersInterface = {};
    superBookFilters: UserBookFiltersInterface = {};
    smartBookFilters: UserBookFiltersInterface = {};
    //Both Maps store symbol_id as key and orderbook/tradebook response
    _symbolIdOrderBookMap = new Map<number, OrderBook[]>();
    _symbolIdTradeBookMap = new Map<number, TradeBook[]>();
    _symbolIdGTTBookMap = new Map<number, GTTBook[]>();
    _symbolIdSuperBookMap = new Map<string, SuperBook[]>();
    _symbolIdSmartBookMap = new Map<string, SuperBook[]>();

    /**
     * These flags are used to check if the data is being synced from server or not.
     * Using individual flags to avoid cases like some data is synced and other is in progress.
     */
    isSyncingOrders = false;
    isSyncingTrades = false;
    isSyncingHoldings = false;
    isSyncingPositions = false;
    isSyncingMutualFunds = false;
    isSyncingGTT = false;
    isSyncingSuperBook = false;
    isSyncingSmartBook = false;
    audioPlayer = new Audio('/assets/audio/order-alert.mp3');

    private filterStates: { [key: string]: object } = {
        tradebook: {},
        holdings: {},
        position: {},
        orderbook: {},
        gttbook: {},
        superbook: {}
    };

    subTabs: SubTabs = {
        bookSubTabs: {
            0: false,
            1: false,
            2: false
        },
        holdingsSubTabs: {
            0: false,
            1: false,
            2: false
        }
    }

    private showAllStates = {
        positions: false,
        holdings: false,
        trades: false,
        orders: false,
        sip: false,
        gttOrders: false,
        superOrders: false,
        mtfHoldings: false
    };

    // This map is used to store the trades for an order.
    // The key is the master_order_id and the value is a map of the trades.
    // The value is a map of the trades.
    // The key is the trade_id and the value is the tradeStruct.
    tradesForOrder = new Map<string, Map<string, TradeStruct>>();
    cachedMTFHoldings: MtfHoldingResponseObj;
    cachedApprovedStockList: ApprovedStockListResponse;
    /** Per order_id_string, set of trade_ids already applied so we don't add the same fill twice. */
    smartOrderAppliedTradeIds = new Map<string, Set<string>>();
    constructor(
        private _httpClient: HttpClient,
        private _socket: SocketService,
        private _eventsService: EventsService,
        private _loggingService: LoggingService,
        private _toastr: ToastrService,
        private _config: ConfigParamsService,
        private _dialogRef: MatDialog,
        private _symbolSearchService: SymbolSearchService,
        private _orderNotificationService: OrderNotificationService,
        private _configService: ConfigurationService
    ) {

        this._eventsService.subscribe(EVENTS.SOCKET_AUTHENTICATED, (isFirstConnection) => {
            if (!isFirstConnection) {
                this.isSyncingOrders = true;
                this.isSyncingTrades = true;
                this.isSyncingHoldings = true;
                this.isSyncingPositions = true;
                this.isSyncingMutualFunds = true;
                this.isSyncingGTT = true;
                this.isSyncingSuperBook = true;
                this.isSyncingSmartBook = true;
                this.syncUserBookData();
            }
            else {
                this.isSyncingOrders = false;
                this.isSyncingTrades = false;
                this.isSyncingHoldings = false;
                this.isSyncingPositions = false;
                this.isSyncingMutualFunds = false;
                this.isSyncingGTT = false;
                this.isSyncingSuperBook = false;
                this.isSyncingSmartBook = false;
            }
        });

        // Subscribe to OPEN_AUTHORIZATION_DIALOG event to open dialog with specific holding
        this._eventsService.subscribe(EVENTS.OPEN_AUTHORIZATION_DIALOG, (holdingResponse: any) => {
            if (holdingResponse && holdingResponse.length) {
                this.openAuthorizationDialog(holdingResponse);
            }
        });
    }

    getFormattedSymbolName(symbol: OrderBookDataResponse | TradesResponseDataInterface | GTTOrderBookTable) {
        return this._symbolSearchService.getFormattedSymbol(Utils.getUniqueKey(symbol.market_id, symbol.security_id));
    }

    listenOrderUpdates() {
        this._subscriptions.add(this._socket.getFeed(SocketConnections.order, SockRoutes.orderbook)
            .subscribe((orders: OrderBookDataResponse[]) => {
                if (orders && orders.length) {
                    // TODO: Replace Object.assign with spread Operator
                    const data = Object.assign([], this.cachedOrders);
                    let orderBookData: OrderBook[] = [];
                    orders.reverse().forEach(order => {
                        if(!order.formatted_symbol) {
                            order.formatted_symbol = this.getFormattedSymbolName(order);
                        }
                        this.setLatestSeqNum(order.seq_num);
                        const orderBookObj = new OrderBook(order, this._config);
                        this.addInOrderBookMap(orderBookObj);

                        // Check if Order previously Visible
                        let index = -1;
                        if (order.exchange_order_id &&
                            order.exchange_order_id !== '' &&
                            order.order_status !== OrderStatus.rms_reject) {
                            // Proceed without checking order.exchange_order_id(for scheduling it will be 0 everytime) and amo check(amo disabled for scheduling)
                            if ([OrderStatus.schedule_replaced, OrderStatus.schedule_pending, OrderStatus.schedule_cancelled,
                            OrderStatus.schedule_rejected, OrderStatus.cancelled, OrderStatus.schedule_new].includes(order.order_status as OrderStatus)) {
                                index = data.findIndex(iOrder => orderBookObj.master_order_id === iOrder.master_order_id &&
                                    VALID_ORDERS.includes(iOrder.order_status));
                            } else {
                                // If order is not AMO and exchange order id is 0, then we have to create a separate row.
                                if (!(order.order_category !== OrderCategory.amo && order.exchange_order_id === '0')) {
                                    index = data.findIndex(iOrder => orderBookObj.master_order_id === iOrder.master_order_id &&
                                        VALID_ORDERS.includes(iOrder.order_status));
                                }
                            }
                        }

                        if (index >= 0) {
                            // data[index] = orderBookObj;
                            const oldOrder = data[index];
                            this._loggingService.debug(['Old Order', oldOrder, typeof (oldOrder), oldOrder.updateOrder]);
                            data.splice(index, 1);
                            if (this.filterValidator.isValidFilteredOrderBookRow(orderBookObj, this.orderbookFilters)) {
                                // If new row does not satisfy filters than we will remove old row and not add new row.
                                oldOrder.updateOrder(order);
                                this._loggingService.debug(['Updated Order', oldOrder]);
                                data.unshift(oldOrder);
                            }
                        } else {
                            const amoIndex = data.findIndex(iOrder => orderBookObj.master_order_id === iOrder.master_order_id);

                            if ((this.filterValidator.isValidFilteredOrderBookRow(orderBookObj, this.orderbookFilters)) ||
                                (orderBookObj.order_category === OrderCategory.multileg)) {
                                // RT-9360 : all rejected orders are sent again by dms irrespective of its category
                                // splice them otherwise this will cause duplicate entries in order book
                                // If amo order is triggered and got rms rejected or new rejected, it should splice the existing amo order.
                                if ((order.order_status === OrderStatus.rms_reject || order.order_status === OrderStatus.new_rejected) &&
                                    data[amoIndex]
                                ) {
                                    data.splice(amoIndex, 1);
                                }

                                // If new row does not satisfy filters than we will not add new row.
                                data.unshift(orderBookObj);
                                orderBookData.push(orderBookObj)
                            }
                        }
                        // commented for now, will be enabled with pop ups
                        if (!this.isSyncingOrders) {
                            if (orderBookObj.master_order_id != this.processedOrderId
                                && ExecutedOrderStatus.includes(order.order_status as OrderStatus)) {
                                this.playAudio(orderBookObj.master_order_id);
                            }
                            this.showOrderNotification(order);
                        }
                    });
                    this.cachedOrders = data;
                    this.orderBookStream.next({
                        filter: true,
                        data: orderBookData
                    });
                    if (!this.isSyncingOrders) {
                        this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 1);

                        // Process order book data to determine which tabs need updates
                        // Iterate through orders and mark tabs that need updates
                        if (orders.length > 0) {
                            orders.forEach(order => {

                                // For filled or partially_filled orders, only set tradeBook to true
                                if (ORDER_STATUS_TAB_MAPPING[order.order_status] === BOOK_TABS.TRADE_BOOK) {
                                    this.subTabs.bookSubTabs[1] = true;
                                } else {
                                    // For other statuses, set the orderbook tab to true 
                                    this.subTabs.bookSubTabs[0] = true;
                                }
                            });

                            // Publish event with array of tabs that need updates
                            this._eventsService.publish(EVENTS.DASH_TAB_UPDATES_BOOK, this.subTabs.bookSubTabs);
                        }
                    }
                }
            }));

        /**
         * Check if Trade is in Order Id
         */
        this._subscriptions.add(this._socket.getFeed(SocketConnections.order, SockRoutes.tradebook)
            .subscribe((trades: any[]) => {
                if (trades && trades.length) {
                    const data = Object.assign([], this.cachedOrders);
                    trades.forEach(trade => {
                        trade.formatted_symbol = this.getFormattedSymbolName(trade);
                        // MH-8571
                        // if (this.modifyDialogRef && this.modifyDialogRef['exchange_order_id']
                        //     && this.modifyDialogRef['exchange_order_id'] === trade.exchange_order_id) {
                        //     this.modifyDialogRef['dialogRef'].close();
                        //     this.modifyDialogRef = {};
                        // }
                        const tradeBookObj = new TradeBook(trade, this._config);
                        this.updateTrades(tradeBookObj);
                        /**
                         * When a trade (fill) arrives from the tradebook stream and we're not syncing from server,
                         * try to attach it to a smart order so we can update executed qty and average price.
                         * Matching is by fix_cl_order_id (parent or slice order id). If a smart order is found,
                         * we apply this fill once (deduped by trade_id) and emit an updated smart order.
                         */
                        if (!this.isSyncingTrades) {
                            const fixClOrderId = (trade.fix_cl_order_id ?? tradeBookObj.fix_cl_order_id ?? '').toString();
                            if (fixClOrderId) {
                                const smartOrder = this.findSmartOrderByFixClOrderId(fixClOrderId);
                                if (smartOrder) {
                                    this.addTradeToSmartOrderAndUpdate(tradeBookObj, smartOrder);
                                }
                            }
                        }
                        const index = data.findIndex(iOrder => tradeBookObj.exchange_order_id === iOrder.exchangeOrderId);
                        if (index >= 0) {
                            data.splice(index, 1);
                        }
                        if (!this.isSyncingTrades &&
                            tradeBookObj.master_order_id.toString() != this.processedOrderId &&
                            ExecutedOrderStatus.includes(trade.order_status as OrderStatus)) {
                            this.playAudio(tradeBookObj.master_order_id.toString());
                        }
                    });
                    this.cachedOrders = data;
                    this.orderBookStream.next();
                    if (!this.isSyncingTrades) {
                        this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 1);
                    }
                }
            }));
        this._subscriptions.add(this._socket.getFeed(SocketConnections.order, SockRoutes.rejection)
            .subscribe(rejection => {
                if (rejection && rejection.length) {
                    for (const i in rejection) {
                        // Add the rejected order id to the set of rejected order ids for order_status like replace_rejected
                        this.rejectedOrderIds.add(rejection[i].master_order_id);
                        rejection[i].formatted_symbol = this.getFormattedSymbolName(rejection[i]);
                        // Show the order notification for the rejected order
                        this._orderNotificationService.show(rejection[i]);
                    }
                }
            }));

        this._subscriptions.add(
            this._socket.getFeed(SocketConnections.order, SockRoutes.bocoData).subscribe((boco_map) => {

                try {
                    const data = Object.assign([], this.cachedOrders);

                    data
                        .filter((order: OrderBook) => boco_map[order.generated_order_id])
                        .map((order: OrderBook) => order.updateOrder(boco_map[order.generated_order_id]));

                    this.cachedOrders = data;
                    this.orderBookStream.next();
                } catch { }
            })
        );
    }


    /**
    * This method subscribes to the pledge status socket feed and processes incoming updates.
    * When pledge status updates are received, it:
    * 1. Groups updates by request ID
    * 2. Categorizes symbols into successful and rejected pledges
    * 3. Opens a notification dialog showing the status of each pledge
    */
    listenPledgeUpdates() {
        this._subscriptions.add(
            this._socket.getFeed(SocketConnections.order, SockRoutes.pledge)
                .subscribe((pledgeUpdates: PledgeConfirmStatusResponse) => {
                    // Check if the response is an array directly
                    if (Array.isArray(pledgeUpdates) && pledgeUpdates.length > 0) {
                        // Group updates by request ID
                        const requestGroups = {};
                        pledgeUpdates.forEach(update => {
                            if (!requestGroups[update.req_id]) {
                                requestGroups[update.req_id] = [];
                            }
                            requestGroups[update.req_id].push(update);
                        });
                        Object.keys(requestGroups).forEach(reqId => {
                            const rows = requestGroups[reqId];
                            this.showPledgeStatusDialog(rows);
                        });
                    }
                })
        );
    }

    // This method is used to show the pledge status dialog
    showPledgeStatusDialog(rows: PledgeConfirmStatusRows[]) {
        // If a dialog is already open, returning.
        if (this.pledgeStatusDialogRef) {
            return;
        }
        const successfulSymbols = [];
        const rejectedSymbols = [];
        const overdueSymbols = [];
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            // Check status and add to appropriate array
            if (row.isin_req_status === PledgeResponseStatus.success) {
                successfulSymbols.push(row.symbol_name);
            } else if (row.isin_req_status === PledgeResponseStatus.failure) {
                rejectedSymbols.push(row.symbol_name);
            } else if (row.isin_req_status === PledgeResponseStatus.overdue) {
                overdueSymbols.push(row.symbol_name);
            }
        }
        // Only show dialog if we have symbols to display
        if (successfulSymbols.length > 0 || rejectedSymbols.length > 0 || overdueSymbols.length > 0) {
            this.pledgeStatusDialogRef = this._dialogRef.open(PledgeStatusNudgeComponent, {
                data: {
                    successfulPledges: successfulSymbols,
                    failedPledges: rejectedSymbols,
                    overduePledges: overdueSymbols
                },
                width: '350px',
                panelClass: ['pledge-report-dialog-panel', 'dialog-no-padding']
            });
            // Clear reference when dialog is closed
            this.pledgeStatusDialogRef.afterClosed().subscribe(() => {
                this.pledgeStatusDialogRef = null;
            });
            // Update holdings after pledge updates
            this._eventsService.publish(EVENTS.UPDATE_HOLDINGS);
        }
    }

    listenHoldingUpdates() {
        this._socket.getFeed(SocketConnections.order, SockRoutes.holding)
            .subscribe((holdings: HoldingResponseObj) => {
                if (holdings && Object.keys(holdings).length) {

                    Object.entries(holdings).forEach(([key, holding]) => {
                        holding.formatted_symbol = holding.symbol;
                        if (this.cachedHoldings.data[key]) {
                            if (!holding.total_qty) {
                                delete this.cachedHoldings.data[key];
                            }
                            else {
                                this.cachedHoldings.data[key] = holding;
                            }
                        }
                        else {
                            this.cachedHoldings.data[key] = holding;
                        }
                    })
                    this.holdingStream.next(holdings);
                    if (!this.isSyncingHoldings) {
                        this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 3);
                        if (Object.keys(holdings).length > 0) {
                            this.subTabs.holdingsSubTabs[0] = true;
                            this.subTabs.holdingsSubTabs[1] = true;
                            this._eventsService.publish(EVENTS.DASH_TAB_UPDATES_BOOK, this.subTabs.holdingsSubTabs);
                        }
                    }
                }

            });
    }

    listenMTFUpdates() {
        this._socket.getFeed(SocketConnections.order, SockRoutes.mtf)
                .subscribe((mtfData: MtfHoldingResponseObj) => {
                if (mtfData && Object.keys(mtfData).length) {
                    this.mtfStream.next(mtfData);
                }
            });
    }

    listenMTFMarginUpdates() {
        this._socket.getFeed(SocketConnections.order, SockRoutes.mtfMargin)
            .subscribe((mtfMarginData: MtfMarginResponseObj) => {
                if (mtfMarginData && Object.keys(mtfMarginData).length) {
                    this.mtfMarginStream.next(mtfMarginData);
                }
            });
    }

    listenMutualFundUpdates() {
        this._socket.getFeed(SocketConnections.order, SockRoutes.mutualFund)
            .subscribe((response: MutualFundHoldingResponseRealTime) => {
                if (response?.SHAREINDIA && response?.SHAREINDIA?.length) {
                    const mutualFundData = response.SHAREINDIA ?? [];

                    // Handle SHAREINDIA mutual funds
                    if (mutualFundData?.length) {
                        const data = [...(this.cachedMutualFunds || [])];

                        mutualFundData.forEach(fund => {
                            // Find existing fund by ISIN
                            const existingFundIndex = data.findIndex(f => f.isin === fund.isin);

                            const mutualFundObj = new MutualFund(fund, VendorType.shareIndia);

                            if (existingFundIndex !== -1) {
                                // Update existing fund
                                if (fund.balanceUnits > 0) {
                                    data[existingFundIndex] = mutualFundObj;
                                }
                                else {
                                    data.splice(existingFundIndex, 1);
                                }
                            } else {
                                // Add new fund
                                data.unshift(mutualFundObj);
                            }
                        });

                        this.cachedMutualFunds = data;
                        this.mutualFundStream.next(mutualFundData);
                        if (!this.isSyncingMutualFunds) {
                            this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 3);
                        }
                    }
                }
            });
    }

    openAuthorizationDialog(authorizationData) {
        const injectEdisData: EdisAuthUnauth = {
            selectedHolding: authorizationData
        };
        this._dialogRef.open(AuthorizationHoldingsSelectorComponent, {
            data: injectEdisData,
            minWidth: '640px',
            panelClass: 'expanding-dialog'
        })
    }

    listenTradeUpdates() {
        this._socket.getFeed(SocketConnections.order, SockRoutes.tradebook)
            .subscribe((orders: any[]) => {
                if (orders && orders.length) {
                    const data = Object.assign([], this.cachedTrades);
                    let tradeBookData: TradeBook[] = [];
                    orders.reverse().forEach(order => {
                        this.setLatestSeqNum(order.seq_num);
                        if(!order.formatted_symbol) {
                            order.formatted_symbol = this.getFormattedSymbolName(order);
                        }
                        const orderBookObj = new TradeBook(order, this._config);
                        this.addinTradeBookMap(orderBookObj);

                        // Check if Order previously Visible
                        const index = data.findIndex(iOrder =>
                            orderBookObj.symbol_id === iOrder.symbol_id &&
                            orderBookObj.side === iOrder.side &&
                            orderBookObj.trade_id === iOrder.trade_id
                        );
                        if (index >= 0) {
                            if (this.filterValidator.isValidFilterdTradeBookRow(orderBookObj, this.tradebookFilters)) {
                                data[index] = orderBookObj;
                            } else {
                                // If Not valid not trade row, remove it from table.
                                data.splice(index, 1);
                            }
                        } else {
                            if (this.filterValidator.isValidFilterdTradeBookRow(orderBookObj, this.tradebookFilters)) {
                                // Only add to table if new trade book row in validated with filters.
                                data.unshift(orderBookObj);
                                tradeBookData.push(orderBookObj);
                            }
                        }
                    });
                    this.cachedTrades = data;
                    this.tradebookStream.next({
                        filter: true,
                        data: tradeBookData
                    });
                    this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 1);
                }
            });
    }

    listenGTTUpdates() {
        this._subscriptions.add(this._socket.getFeed(SocketConnections.order, SockRoutes.gttbook)
            .subscribe((gttOrders: any) => {
                if (gttOrders && typeof gttOrders === 'object' && gttOrders.order_data) {
                    const data = Object.assign([], this.cachedGTTOrders || []);
                    const gttBookObj = new GTTBook(gttOrders.order_data);
                    if (gttBookObj && !gttBookObj.formatted_symbol) {
                        // Format the symbol for display
                        gttBookObj.formatted_symbol = this.getFormattedSymbolName(gttBookObj);
                    }
                    this.addInGTTBookMap(gttBookObj);
                    const existingIndex = data.findIndex(order => order.id === gttBookObj.id);

                    let gttBookData: GTTBook[] = [];
                    if (existingIndex !== -1) {
                        // Update existing order
                        data[existingIndex] = gttBookObj;
                    } else {
                        // Add new order at the beginning
                        data.unshift(gttBookObj);
                    }
                    this.cachedGTTOrders = data;
                    this.gttBookStream.next({
                        data: {
                            orders: [gttBookObj],
                            pagination: {
                                page: 1,
                                page_size: 10,
                                total_count: 10,
                                total_pages: 1
                            }
                        },
                    });
                    // Show GTT notification if not syncing
                    if (!this.isSyncingGTT) {
                        this.showGTTOrderNotification(gttBookObj, gttOrders.event_type, gttOrders.is_triggered);
                        this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 1);
                    }
                }
            }));
    }

    /**
     * Add a trade to the smart-order map (key = order_id_string, value = map of trade_id -> { price, quantity }), then aggregate and update smart order.
     * Use this when a fill arrives from orders/trades stream; matching is by fix_cl_order_id so it works when strategyorders is null.
     */
    addTradeToSmartOrderAndUpdate(trade: TradeBook, smartOrder: SuperBook): void {
        const orderIdString = smartOrder.order_id_string;
        const tradeId = trade.trade_id ? String(trade.trade_id) : '';
        const fillQty = Number(trade.last_filled_qty) || 0;
        const fillPriceRaw = Number(trade.last_filled_price) || 0;

        if (!tradeId || (fillQty <= 0 && fillPriceRaw <= 0)) return;

        // Dedupe: skip if we already applied this trade
        if (!this.smartOrderAppliedTradeIds.has(orderIdString)) {
            this.smartOrderAppliedTradeIds.set(orderIdString, new Set<string>());
        }
        const appliedIds = this.smartOrderAppliedTradeIds.get(orderIdString)!;
        if (appliedIds.has(tradeId)) return;
        appliedIds.add(tradeId);

        const state = smartOrder.strategy_state ?? (smartOrder.strategy_state = {});

        // Current totals from API / previous updates
        const previousQty = Number(state.executed_quantity) || 0;
        const previousAvgPrice = Number(state.average_price) || 0;

        // This fill: convert price to same unit as API (e.g. paise)
        const precision = smartOrder.symbol_data?.scrip_precision ?? trade.scrip_precision ?? 2;
        const fillPriceInUnit = fillPriceRaw * Math.pow(10, precision);

        // New totals
        const totalQty = previousQty + fillQty;
        const totalValue = previousQty * previousAvgPrice + fillQty * fillPriceInUnit;  // sum of (qty × price)
        const newAvgPrice = totalQty > 0 ? totalValue / totalQty : previousAvgPrice;

        state.executed_quantity = totalQty;
        state.average_price = newAvgPrice;
        smartOrder.strategy_state.last_fill_price = fillPriceInUnit;
        smartOrder.strategy_state.executed_quantity = totalQty;

        // Update cache and notify UI
        this.addInSmartBookMap(smartOrder);
        const smartData = [...(this.cachedSmartOrders || [])];
        const idx = smartData.findIndex(o => o.order_id_string === orderIdString);
        if (idx !== -1) smartData[idx] = smartOrder;
        else smartData.unshift(smartOrder);
        this.cachedSmartOrders = smartData;
        this.smartBookStream.next({ orders: [smartOrder], count: 1 });
    }

    /**
    * Find a smart order that matches the given fix_cl_order_id or master_order_id
    * (parent order_id_string or any slice in strategyorders).
    */
    findSmartOrderByFixClOrderId(fixClOrderId: string): SuperBook | null {
        if (!this.cachedSmartOrders?.length) {
            return null;
        }
        const fixId = fixClOrderId ? String(fixClOrderId).trim() : '';
        if (!fixId) {
            return null;
        }
        return this.cachedSmartOrders.find(s => {
            if (s.order_id_string === fixId) {
                return true;
            }
            const orderIds = s.calculated_values?.strategyorders?.order_ids;
            if (orderIds && typeof orderIds === 'object' && orderIds[fixId] === true) {
                return true;
            }
            return false;
        }) || null;
    }

    // To fetch order book from server(raw response)
    fetchOrderBook(orderBookRequest: UserBookFilters) {
        const url = applicationUrls.orderBookUrl;
        if (this.$orderRequest) { return this.$orderRequest; }
        this.$orderRequest = this._httpClient.get<OrderBookResponse>(url, {
            params: <any>orderBookRequest
        }).pipe(
            share()
        );
        return this.$orderRequest;
    }

    // To fetch trade book from server(raw response)
    fetchTradeBook(tradeRequest: UserBookFilters) {
        const url = applicationUrls.getTradeList;
        if (this.$tradesRequest) { return this.$tradesRequest; }
        this.$tradesRequest = this._httpClient.get<TradesResponseInterface>(url, {
            params: <any>tradeRequest
        }).pipe(
            share()
        );
        return this.$tradesRequest;
    }

    fetchGTTBook(gttBookRequest: UserBookFilters) {
        const url = applicationUrls.gttBookUrl;
        if (this.$gttRequest) { return this.$gttRequest; }
        this.$gttRequest = this._httpClient.get<GTTBookResponse>(url, {
            params: <any>gttBookRequest
        }).pipe(share());
        return this.$gttRequest;
    }

    cancelOrder(cancelOrderRequest: CancelOrderRequest | Order) {
        const url = applicationUrls.modifyOrderUrl;
        return this._httpClient.request<CancelOrderResponse>('delete', url, { body: cancelOrderRequest });
    }

    getPositionsData(refresh = false, positonRequest: UserBookFilters) {

        const url = applicationUrls.getPositionList;
        if (!refresh && this.cachedPositions && this.cachedPositions.data) {
            return of(this.cachedPositions);
        }
        if (this.$positionRequest) { return this.$positionRequest; }

        this.$positionRequest = this._httpClient.get<PositionResponse>(url, {
            params: <any>positonRequest
        }).pipe(
            share(),
            tap(res => {
                this.cachedPositions = res;
            })
        );
        return this.$positionRequest;
    }

    getTransactionHistory(transactionHistoryParams: TransactionHistoryParams) {
        const url = applicationUrls.getTransactionHistory;
        return this._httpClient.get<OrderBookDataResponse[]>(url, {
            params: <any>transactionHistoryParams
        });
    }

    getHoldings(refresh = false, filter?: HoldingBookFilters) {
        const url = applicationUrls.getHoldings;
        if (!refresh && this.cachedHoldings && this.cachedHoldings.data) {
            return of(this.cachedHoldings);
        }
        if (this.$holdingRequest) { return this.$holdingRequest; }

        this.$holdingRequest = this._httpClient.get<HoldingResponse>(url, {
            params: <any>filter
        }).pipe(
            share(),
            tap(res => {
                this.cachedHoldings = res;
            })
        );
        return this.$holdingRequest;
    }

    getMTFHoldingsData() {
        const url = applicationUrls.getMTFHoldings;
        return this._httpClient.get<MtfHoldingResponse>(url);
    }

    getMTFHoldings() {
        if (this.cachedMTFHoldings && Object.keys(this.cachedMTFHoldings).length) {
            return of(this.cachedMTFHoldings);
        }
        
        return this.getMTFHoldingsData().pipe(
            map(res => {
                if (!res) return [];
                const filteredData: MtfHoldingResponseObj = {};
                Object.entries(res.data).forEach(([key, holding]) => {
                    if ((holding.qty || 0) > 0) {
                    filteredData[key] = holding;
                    }
                });
                return this.cachedMTFHoldings = filteredData;
            })
        );
        
    }

    getApprovedStockList() {
        if (this.cachedApprovedStockList) {
            return of(this.cachedApprovedStockList);
        }
        const url = applicationUrls.getApprovedStockList;
        return this._httpClient.get<ApprovedStockListResponse>(url).pipe(
            tap(res => {
                this.cachedApprovedStockList = res;
            })
        );
    }

    convertPosition(request: ConvertProductRequest[]) {
        const url = applicationUrls.converPosition;
        return this._httpClient.post<ConvertProductRsponse>(url, { products: request });
    }

    getProductConversionSummary(filter: UserBookFilters) {
        const url = applicationUrls.productConverionSummary;
        return this._httpClient.get<ProductConversionSummaryResponse>(url, {
            params: <any>filter
        });
    }

    getMutualFundHoldings() {
        const url = applicationUrls.getMutualFundHoldings;
        return this._httpClient.get<MutualFundHoldingResponse>(url);
    }

    getMutualFundData() {
        if (this.cachedMutualFunds?.length) {
            return of(this.cachedMutualFunds);
        }

        return this.getMutualFundHoldings().pipe(
            map(response => {
                if (!response?.data) return [];

                const allFunds: MutualFund[] = [];
                // Convert broker-wise data to flat array
                Object.entries(response.data).forEach(([broker, funds]) => {
                    const brokerFunds = funds.map(fund => new MutualFund(fund, broker));
                    allFunds.push(...brokerFunds);
                });
                this.cachedMutualFunds = allFunds;
                return this.cachedMutualFunds;
            })
        );
    }

    setSearchAutocompletion(searchControl: UntypedFormControl, autocompleteOptions: string[]) {
        return searchControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value, autocompleteOptions))
        );
    }

    // Filters the given value (from input) and checks if its a substring of any element in the given options array
    _filter(value: string, autocompleteOptions: string[]) {
        return autocompleteOptions
            .filter((option: string) => option.toLowerCase().includes(value.toLowerCase()));
    }


    setLatestSeqNum(seqNum: number) {
        if (seqNum > this.lastestSeqNum) {
            this.lastestSeqNum = seqNum;
        }
    }

    syncUserBookData() {
        const filters: UserBookFilters = {};
        filters.seq_num = this.lastestSeqNum;
        new Promise<void>((resolve) => {
            this.fetchOrderBook(filters).subscribe((orders) => {
                this._socket.getFeed(SocketConnections.order, SockRoutes.orderbook).next(orders.data);
                resolve();
            });
        }).then(() => {
            this.isSyncingOrders = false;
        });

        new Promise<void>((resolve) => {
            this.fetchTradeBook(filters).subscribe((trades) => {
                this._socket.getFeed(SocketConnections.order, SockRoutes.tradebook).next(trades.data);
                resolve();
            });
        }).then(() => {
            this.isSyncingTrades = false;
        });

        new Promise<void>((resolve) => {
            this.getPositionsData(true, filters).subscribe((positions) => {
                this._socket.getFeed(SocketConnections.order, SockRoutes.postions).next(positions.data);
                resolve();
            });
        }).then(() => {
            this.isSyncingPositions = false;
        });

        new Promise<void>((resolve) => {
            this.getHoldings(true, filters).subscribe((holdings) => {
                this._socket.getFeed(SocketConnections.order, SockRoutes.holding).next(holdings.data);
                resolve();
            });
        }).then(() => {
            this.isSyncingHoldings = false;
        });

        new Promise<void>((resolve) => {
            this.getMutualFundHoldings().subscribe((mutualFunds) => {
                this._socket.getFeed(SocketConnections.order, SockRoutes.mutualFund).next(mutualFunds);
                resolve();
            });
        }).then(() => {
            this.isSyncingMutualFunds = false;
        });

        new Promise<void>((resolve) => {
            this.getGTTBookData({}).subscribe((gttBook) => {
                this._socket.getFeed(SocketConnections.order, SockRoutes.gttbook).next(gttBook);
                resolve();
            });
        }).then(() => {
            this.isSyncingGTT = false;
        });
        
        const isSuperEnabled = this._configService.remoteConfigCacheObj?.['IS_SUPER_ENABLED'] !== undefined
            ? this._configService.remoteConfigCacheObj?.['IS_SUPER_ENABLED']
            : true;
        if (isSuperEnabled) {
            new Promise<void>((resolve) => {
                this.getSuperBookData({}).subscribe((superBook) => {
                    resolve();
                });
            }).then(() => {
                this.isSyncingSuperBook = false;
            });
        }
    }

    // To get orderbook cached data.
    getOrderBookData(userBookFilters: UserBookFilters) {
        if (this.cachedOrders && this.cachedOrders.length) {
            return of(this.cachedOrders);
        } else {
            this._symbolIdOrderBookMap.clear();
            return this.fetchOrderBook(userBookFilters).pipe(map(res => {
                if (res && res.data) {
                    const orderBookData = [];
                    res.data.forEach(order => {
                        this.setLatestSeqNum(order.seq_num);
                        const orderResponse = new OrderBook(order, this._config);
                        orderBookData.push(orderResponse);
                        this.addInOrderBookMap(orderResponse);
                    });
                    orderBookData.sort(SharedUtils.sortByKey('modified', SortingTypes.Descending))
                    this.cachedOrders = orderBookData;
                    return this.cachedOrders;
                }
            }));
        }
    }

    // To get tradebook cached data.
    getTradeData(userBookFilters: UserBookFilters) {

        if (this.cachedTrades && this.cachedTrades.length) {
            return of(this.cachedTrades);
        } else {
            this._symbolIdTradeBookMap.clear();
            return this.fetchTradeBook(userBookFilters).pipe(map(res => {
                if (res && res.data) {
                    const tradeBookData = [];
                    res.data.forEach(trade => {
                        this.setLatestSeqNum(trade.seq_num);
                        const tradeResponse = new TradeBook(trade, this._config);
                        this.updateTrades(tradeResponse);
                        tradeBookData.push(tradeResponse);
                        this.addinTradeBookMap(tradeResponse)
                    });
                    this.cachedTrades = tradeBookData;
                    return this.cachedTrades;
                }
            }));
        }
    }
// Get GTT Book cached data
getGTTBookData(userBookFilters: UserBookFilters) {
    if (this.cachedGTTOrders && this.cachedGTTOrders.length) {
        return of(this.cachedGTTOrders);
    } else {
        this._symbolIdGTTBookMap.clear();
        return this.fetchGTTBook(userBookFilters).pipe(map(res => {
            if (res && res.data && res.data.orders) {
                const gttBookData = [];
                res.data.orders.forEach(order => {
                    const gttBookObj = new GTTBook(order);
                    gttBookData.push(gttBookObj);
                    this.addInGTTBookMap(gttBookObj);
                });
                this.cachedGTTOrders = gttBookData;
                return this.cachedGTTOrders;
            }
        }));
    }
}

    addinTradeBookMap(orderBookObj: TradeBook) {
        if (this._symbolIdTradeBookMap.has(orderBookObj.symbol_id)) {
            this._symbolIdTradeBookMap.get(orderBookObj.symbol_id).push(orderBookObj);
        }
        else {
            this._symbolIdTradeBookMap.set(orderBookObj.symbol_id, [orderBookObj]);
        }
    }

    addInOrderBookMap(orderBookObj: OrderBook) {
        if (this._symbolIdOrderBookMap.has(orderBookObj.symbol_id)) {
            this._symbolIdOrderBookMap.get(orderBookObj.symbol_id).push(orderBookObj);
        }
        else {
            this._symbolIdOrderBookMap.set(orderBookObj.symbol_id, [orderBookObj]);
        }
    }

    addInGTTBookMap(gttBookObj: GTTBook) {
        if (this._symbolIdGTTBookMap.has(gttBookObj.symbol_id)) {
            this._symbolIdGTTBookMap.get(gttBookObj.symbol_id).push(gttBookObj);
        }
        else {
            this._symbolIdGTTBookMap.set(gttBookObj.symbol_id, [gttBookObj]);
        }
    }

    getSuperBookData(userBookFilters: UserBookFilters) {
        if (this.cachedSuperOrders && this.cachedSuperOrders.length) {
            return of(this.cachedSuperOrders);
        } else {
            return this.fetchSuperBook(userBookFilters).pipe(map(res => {
                // Fix: Check for orders directly in response, not under data.orders
                if (res && res['orders'] && res['orders'].length) {
                    const superBookData = [];
                    res['orders'].forEach((order: any) => {
                        const superBookObj = new SuperBook(order);
                        superBookData.push(superBookObj);
                    });
                    this.cachedSuperOrders = superBookData;
                    return this.cachedSuperOrders;
                }
                return [];
            }));
        }
    }

    fetchSuperBook(superBookRequest: UserBookFilters) {
        const url = applicationUrls.superBookUrl + `${WEB_SmartOrderType.SMART_ORDER_TYPE_SUPER_BOCO}/`;
        if (this.$superRequest) { return this.$superRequest; }
        this.$superRequest = this._httpClient.get<SmartBookResponse>(url, {
            params: <any>superBookRequest
        }).pipe(share());
        return this.$superRequest;
    }

    getSmartBookData(userBookFilters: UserBookFilters) {
        if (this.cachedSmartOrders && this.cachedSmartOrders.length) {
            return of(this.cachedSmartOrders);
        } else {
            return this.fetchSmartBook(userBookFilters).pipe(map(res => {
                if (res && res['orders'] && res['orders'].length) {
                    const smartBookData = [];
                    res['orders'].forEach((order: SmartBookTable) => {
                        const smartBookObj = new SuperBook(order);
                        smartBookData.push(smartBookObj);
                    });
                    this.cachedSmartOrders = smartBookData;
                    return this.cachedSmartOrders;
                }
                return [];
            }));
        }
    }

    fetchSmartBook(smartBookRequest: UserBookFilters) {
        const url = applicationUrls.smartBookUrl + `${WEB_SmartOrderType.SMART_ORDER_TYPE_TWAP},${WEB_SmartOrderType.SMART_ORDER_TYPE_POV},${WEB_SmartOrderType.SMART_ORDER_TYPE_ICEBERG}/`;
        if (this.$smartRequest) { return this.$smartRequest; }
        this.$smartRequest = this._httpClient.get<SmartBookResponse>(url, {
            params: <any>smartBookRequest
        }).pipe(share());
        return this.$smartRequest;
    }

    // To play audio for executed order/trade
    // audio sound is system dependent and is stored in /src/app/_shared/audio/audio.ts
    playAudio(id: string) {
        this.processedOrderId = id;
        this.audioPlayer.play();
    }


    // This is done so that we have latest seq number irrespective of whether we opened orderbook/tradebook or not to handle
    // cases mentioned in RT-10333.
    // To fetch orders and trades and listen for socket updates initially.
    initialize() {
        this.listenOrderUpdates();
        this.listenTradeUpdates();
        this.listenGTTUpdates();
        this.listenSmartBookUpdates();  
        //this.listenPositionUpdates();
        this.listenHoldingUpdates();
        this.listenMTFUpdates();
        this.listenMTFMarginUpdates();
        this.listenPledgeUpdates();
        this.listenMutualFundUpdates();
        this.getOrderBookData({}).subscribe();
        this.getTradeData({}).subscribe();
        this.getGTTBookData({}).subscribe();
        this.getHoldings(true, {}).subscribe();
        this.getPositionsData(true, {}).subscribe();
        this.getMutualFundData().subscribe();
        // Get super and smart book data based on the remote config
        const isSuperEnabled = this._configService.remoteConfigCacheObj?.['IS_SUPER_ENABLED'] !== undefined
            ? this._configService.remoteConfigCacheObj?.['IS_SUPER_ENABLED']
            : true;
        const isSmartEnabled = this._configService.remoteConfigCacheObj?.IS_SMART_ENABLED !== undefined
            ? this._configService.remoteConfigCacheObj?.IS_SMART_ENABLED
            : IS_SMART_ENABLED_DEFAULT;

        if (isSuperEnabled) {
            this.getSuperBookData({}).subscribe();
        }
        if (isSmartEnabled) {
            this.getSmartBookData({}).subscribe();
        }
    }

    // To unsubscribe subscriptions.
    unSubscribe() {
        this._subscriptions.unsubscribe();
    }

    setFilterState(type: 'tradebook' | 'holdings' | 'position' | 'orderbook' | 'gttbook' | 'superbook' | 'approvedStockList' | 'mtfHoldings' | 'smartbook', state: any): void {
        this.filterStates[type] = state;
    }

    getFilterState(type: 'tradebook' | 'holdings' | 'position' | 'orderbook' | 'gttbook' | 'superbook' | 'approvedStockList' | 'mtfHoldings' | 'smartbook'): any {
        return this.filterStates[type];

    }
    setViewPosition(state: string) {
        this.positionView = state;
    }

    getViewPosition() {
        return this.positionView;
    }

    // showing the order notification based on the status set
    showOrderNotification(order: OrderNotificationParams) {
        // Skip those order alerts for the orders which were already shown in rejected orders
        if (this.rejectedOrderIds.has(order.master_order_id)) {
            return;
        }
        this._orderNotificationService.show(order);
    }

    setShowAll(type: string, showAll: boolean) {
        this.showAllStates[type] = showAll;
    }

    getShowAll(type: string): boolean {
        return this.showAllStates[type];
    }


    /**
     * This function updates the trades.
     * It checks if the trade exists in the tradesForOrder map.
     * If it doesn't, it creates a new entry in the map.
     * It then checks if the trade id exists in the map for the given master order id.
     * If it doesn't, it creates a new entry in the map for the trade id.
     * The new entry contains the trade id, time, exchange time, exchange order id, product, quantity, and price of the trade.
     * @param trade - The trade book to update the trades for.
     */
    updateTrades(trade: TradeBook) {
        if (!this.tradesForOrder.has(trade.master_order_id.toString())) {
            this.tradesForOrder.set(trade.master_order_id.toString(), new Map<string, TradeStruct>());
        }

        if (!this.tradesForOrder.get(trade.master_order_id.toString()).has(trade.trade_id)) {
            this.tradesForOrder.get(trade.master_order_id.toString()).set(trade.trade_id, {
                tradeId: trade.trade_id,
                time: trade.conf_receive_time,
                exchangeTime: trade.conf_receive_time,
                exchangeOrderId: trade.exchange_order_id,
                product: trade.product_type,
                quantity: trade.last_filled_qty,
                price: trade.last_filled_price,
                scrip_precision: trade.scrip_precision
            });
        }
    }
    // Add new method for GTT notifications
    showGTTOrderNotification(gttBookObj: any, eventType: string, isTriggered: boolean) {
        const orderData = gttBookObj;
        const notificationParams: OrderNotificationParams = {
            order_mode: orderData.order_mode,
            symbol: orderData.symbol,
            order_status: eventType,
            formatted_symbol: orderData.formatted_symbol,
            id: orderData.id,
            gtt_event_type: eventType,
            is_gtt: true,
            master_order_id: orderData.id?.toString(),
            target_quantity: orderData.target_quantity,
            target_trigger_price: orderData.target_trigger_price,
            is_triggered: isTriggered,
            sl_price: orderData.sl_price,
            sl_quantity: orderData.sl_quantity,
        };

        if (this.rejectedOrderIds.has(notificationParams.master_order_id)) {
            return;
        }

        this._orderNotificationService.show(notificationParams);
    }

    /**
     * Listens for real-time smart book order updates via WebSocket connection.
     * 
     * This function:
     * 1. Subscribes to smart order updates from the socket feed
     * 2. Determines if incoming order is a Super Book or Smart Book based on smart_order_type
     * 3. For Super Book orders (SMART_ORDER_TYPE_SUPER_BOCO):
     *    - Updates cached super orders array by replacing existing or adding new orders
     *    - Notifies UI components via superBookStream
     *    - TODO: Shows notifications if not currently syncing
     * 4. For Smart Book orders:
     *    - Updates cached smart orders array by replacing existing or adding new orders
     *    - Notifies UI components via smartBookStream
     *    - TODO: Shows notifications if not currently syncing
     * 5. Updates dashboard tabs and triggers UI refresh events
     */
    listenSmartBookUpdates() {
        this._subscriptions.add(this._socket.getFeed(SocketConnections.order, SockRoutes.smart_orders_update)
            .subscribe((smartBookOrders: any) => {
                if (smartBookOrders && typeof smartBookOrders === 'object') {
                    const superData = Object.assign([], this.cachedSuperOrders || []);
                    const smartData = Object.assign([], this.cachedSmartOrders || []);

                    const bookObj = new SuperBook(smartBookOrders);

                    const isSuperBook = bookObj.smart_order_type === WEB_SmartOrderType.SMART_ORDER_TYPE_SUPER_BOCO;
                    
                    if (isSuperBook) {
                        this.addInSuperBookMap(bookObj);
                        const existingIndex = superData.findIndex(order => order.order_id_string === bookObj.order_id_string);
    
                        if (existingIndex !== -1) {
                            // Update existing order
                            superData[existingIndex] = bookObj;
                        } else {
                            // Add new order at the beginning
                            superData.unshift(bookObj);
                        }
                        
                        this.cachedSuperOrders = superData;
                        
                        // Send structured response similar to GTT books for consistency
                        this.superBookStream.next({
                            orders: [bookObj],
                            count: 1
                        });
    
                        this.subTabs.bookSubTabs[BOOK_TABS.SUPER_BOOK] = true;
    
                        this._eventsService.publish(EVENTS.DASH_TAB_UPDATES_BOOK, this.subTabs);
                        
                        // Show super book notification if not syncing
                        if (!this.isSyncingSuperBook) {
                            this.showSuperBookOrderNotification(bookObj, smartBookOrders.event_type);
                            this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 1);
                        }
                    } else {
                        this.addInSmartBookMap(bookObj);
                        const existingIndex = smartData.findIndex(order => order.order_id_string === bookObj.order_id_string);
                        if (existingIndex !== -1) {
                            smartData[existingIndex] = bookObj;
                        } else {
                            smartData.unshift(bookObj);
                        }
                        this.cachedSmartOrders = smartData;
                        this.smartOrderAppliedTradeIds.delete(bookObj.order_id_string);
                        this.smartBookStream.next({
                            orders: [bookObj],
                            count: 1
                        });
                        
                        this.subTabs.bookSubTabs[BOOK_TABS.SMART_BOOK] = true;
    
                        this._eventsService.publish(EVENTS.DASH_TAB_UPDATES_BOOK, this.subTabs);
                        
                        if (!this.isSyncingSmartBook) {
                            this.showSmartBookOrderNotification(bookObj, smartBookOrders.event_type);
                            this._eventsService.publish(EVENTS.DASH_TAB_UPDATES, 1);
                        }
                    }
                }
            }));
    }

    // Add helper method similar to GTT books
    addInSuperBookMap(superBook: SuperBook) {
        
        const key = Utils.getUniqueKey(superBook.market_id, superBook.security_id);
        
        if (key) {
            if (!this._symbolIdSuperBookMap.has(key)) {
                this._symbolIdSuperBookMap.set(key, []);
            }
            const existingOrders = this._symbolIdSuperBookMap.get(key);
            const existingIndex = existingOrders.findIndex(order => order.order_id === superBook.order_id);
            
            if (existingIndex !== -1) {
                existingOrders[existingIndex] = superBook;
            } else {
                existingOrders.push(superBook);
            }
            
        } else {
            console.warn('Could not generate key for SuperBook:', superBook);
        }
    }

    addInSmartBookMap(smartBook: SuperBook) {
        const key = Utils.getUniqueKey(smartBook.market_id, smartBook.security_id);
        
        if (key) {
            if (!this._symbolIdSmartBookMap.has(key)) {
                this._symbolIdSmartBookMap.set(key, []);
            }
            const existingOrders = this._symbolIdSmartBookMap.get(key);
            const existingIndex = existingOrders.findIndex(order => order.order_id === smartBook.order_id);
            
            if (existingIndex !== -1) {
                existingOrders[existingIndex] = smartBook;
            } else {
                existingOrders.push(smartBook);
            }
        } else {
            console.warn('Could not generate key for SmartBook:', smartBook);
        }
    }

     // Add notification method
     showSuperBookOrderNotification(superBook: SuperBook, eventType: number) {
        // As per Backend, we need to skip notification when event type is ORDER_CONFIRMATION
        if (eventType === WEB_SM_FeEventType.FE_EVENT_TYPE_ORDER_CONFIRMATION) {
            return;
        }
        // Implement notification logic similar to GTT books
        // const orderData = superBook;
        const notificationParams: OrderNotificationParams = {
            order_mode: SuperBookOrderModeDisplay[superBook.order_mode],
            symbol: superBook.symbol_data.formatted_symbol,
            order_status: SuperBookOrderStatusDisplay[superBook.status],
            formatted_symbol: superBook.symbol_data.formatted_symbol,
            id: Number(superBook.order_id_string),
            super_event_type: eventType,
            is_super: true,      
        };

        if (this.rejectedOrderIds.has(notificationParams.master_order_id)) {
            return;
        }
        this._orderNotificationService.show(notificationParams);
    }

    // Add notification method
    showSmartBookOrderNotification(smartBook: SuperBook, eventType: string) {
        const orderData = smartBook;
        const notificationParams: OrderNotificationParams = {
            order_mode: SuperBookOrderModeDisplay[orderData.order_mode],
            symbol: orderData.symbol_data.formatted_symbol,
            formatted_symbol: orderData.symbol_data.formatted_symbol,
            id: Number(orderData.order_id),
            smart_order_type: orderData.smart_order_type,
            smart_start_time: moment(orderData.start_time * 1000).format(CustomDateTimeFormat.time_only),
            smart_order_status: orderData.status,
            is_smart_order: true,
        };

        if (this.rejectedOrderIds.has(notificationParams.master_order_id)) {
            return;
        }

        this._orderNotificationService.show(notificationParams);
    }

    formatDate(input: string): string {
        // Handle different date formats for robust date parsing
        let date: Date;
        
        /**
         * Parse date input in two ways:
         * 1. DD-MM-YYYY format (e.g., "30-09-2025") - requires manual parsing
         * 2. Other formats (e.g., "30SEP2025") - uses native JS Date parsing
         */
        
        // Check if input is in DD-MM-YYYY format with hyphens
        if (input.includes('-') && input.match(REG_EX.date)) {
          // Manual parsing for DD-MM-YYYY format since JS Date expects MM-DD-YYYY
          const [day, month, year] = input.split('-');
          // Note: month - 1 because JS Date months are 0-indexed (0=Jan, 11=Dec)
          date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        } else {
          // Fallback: Use native JS Date constructor for other formats
          // Handles formats like "30SEP2025", "Sep 30, 2025", ISO strings, etc.
          date = new Date(input);
        }
        
        // Validate the date
        if (isNaN(date.getTime())) {
          return input; // Return original input if parsing fails
        }
        
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
}

